import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
const tzktendpoint = process.env.REACT_APP_TZKT_API_ENDPOINT;
const SingleNFT = () => {
  const { id: nftName } = useParams(); // Get NFT name from URL
  const [nft, setNft] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showBidModal, setShowBidModal] = useState(false);
  const [bidAmount, setBidAmount] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [openMenu0, setOpenMenu0] = useState(true);
  const [openMenu1, setOpenMenu1] = useState(false);
  const [bidError, setBidError] = useState(false);

  const toTez = (mutez) => mutez / 1000000;
  const handleBidChange = (e, currentBid) => {
    const value = e.target.value;
    setBidAmount(value);

    const parsedValue = parseFloat(value);
    if (!isNaN(parsedValue) && parsedValue > currentBid) {
      setBidError(false);
    } else {
      setBidError(true);
    }
  };
  const fetchCreatorName = async (address) => {
    try {
      const response = await fetch(`${tzktendpoint}/v1/accounts/${address}`);
      const data = await response.json();
      return data.alias || address; // Use alias if available, otherwise show address
    } catch (error) {
      console.error("Error fetching creator name:", error);
      return address; // Fallback to address if API call fails
    }
  };
  useEffect(() => {
    const fetchNFT = async () => {
      //const storedAddress = "tz1YS2CmS5o24bDz9XNr84DSczBXuq4oGHxr";
      const storedAddress = localStorage.getItem("walletAddress");
      try {
        const response = await fetch(
          `${tzktendpoint}/v1/tokens/balances?account=${storedAddress}&token.standard=fa2&balance.gt=0&select=token.metadata`
        );
        const data = await response.json();

        // Find the NFT by name (case-insensitive)
        const foundNft = data.find(
          (item) => item.name?.toLowerCase() === nftName.toLowerCase()
        );
        foundNft.creators = await fetchCreatorName(foundNft.creators);
        setNft(foundNft || null);
      } catch (error) {
        console.error("Error fetching NFT:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNFT();
  }, [nftName]);

  if (loading)
    return <p className="text-center text-gray-400">Loading NFT...</p>;
  if (!nft)
    return (
      <div>
        <section className="container">
          <div className="row mt-md-5 pt-md-4">
            <p className="text-center text-red-500"> NFT not found</p>
          </div>
        </section>
      </div>
    );

  const imageFormat = nft.formats?.find((f) => f.mimeType.startsWith("image/"));
  const gifFormat = nft.formats?.find((f) => f.mimeType === "image/gif");
  const videoFormat = nft.formats?.find((f) => f.mimeType.startsWith("video/"));
  const mediaUri =
    imageFormat?.uri || gifFormat?.uri || videoFormat?.uri || nft.displayUri;
  const mediaUrl = mediaUri
    ? mediaUri.replace("ipfs://", "https://ipfs.io/ipfs/")
    : "https://via.placeholder.com/300";

  return (
    <div>
      <section className="container">
        <div className="row mt-md-5 pt-md-4">
          <div className="col-md-6 text-center">
            {/* <img
              src={mediaUrl}
              className="img-fluid img-rounded mb-sm-30"
              alt={nft?.title || "NFT Image"}
              width="100%"
              height="100%"
            /> */}
            {videoFormat ? (
              <video
                className="w-full h-full rounded"
                controls
                autoPlay
                muted
                loop
                loading="lazy"
              >
                <source src={mediaUrl} type={videoFormat.mimeType} />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={mediaUrl}
                loading="lazy"
                alt={nft.name}
                className="w-full h-full rounded"
              />
            )}
          </div>
          <div className="col-md-6">
            <div className="item_info">
              <h2>{nft?.title}</h2>
              <div className="item_info_counts">
                <div className="item_info_type">
                  <i className="fa fa-image"></i> {nft?.category || "Unknown"}
                </div>
                <div className="item_info_views">
                  <i className="fa fa-eye"></i> {nft?.views || 0}
                </div>
                <div className="item_info_like">
                  <i className="fa fa-heart"></i> {nft?.likes || 0}
                </div>
              </div>
              <p>{nft?.description}</p>
              <div className="d-flex flex-row py-10">
                <div className="mr40">
                  <h6>Creator</h6>
                  <div className="item_author">
                    <div className="author_list_pp">
                      <span>
                        <img
                          className="lazy"
                          src={
                            `https://api.dicebear.com/7.x/identicon/svg?seed=${nft.creators?.[0]}` ||
                            "../img/author/author-1.jpg"
                          }
                          alt=""
                        />
                        <i className="fa fa-check"></i>
                      </span>
                    </div>
                    <div className="author_list_info">
                      <span>{nft?.creators || "Unknown Creator"}</span>
                    </div>
                  </div>
                </div>
              </div>

              {nft.tags?.length > 0 && (
                <div className="mt-4 py-10">
                  <h2 className="text-lg font-semibold">Tags:</h2>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {nft.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="px-3 py-1 text-sm bg-gray-200 rounded-full"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              <div className="de_tab">
                <ul className="de_nav">
                  <li id="Mainbtn0" className="active">
                    <span onClick={() => setOpenMenu0(true)}>Details</span>
                  </li>
                  <li id="Mainbtn1">
                    <span onClick={() => setOpenMenu1(true)}>History</span>
                  </li>
                </ul>

                <div className="de_tab_content">
                  {openMenu0 && (
                    <div className="tab-1 onStep fadeIn">
                      <h6>Owner</h6>
                      <p>{nft?.owner || "Not Available"}</p>
                    </div>
                  )}

                  {openMenu1 && (
                    <div className="tab-2 onStep fadeIn">
                      <h6>History</h6>
                      {nft?.history && nft.history.length > 0 ? (
                        nft.history.map((event, index) => (
                          <div key={index}>
                            <p>
                              {event.action} by {event.user} on{" "}
                              {new Date(event.timestamp).toLocaleString()}
                            </p>
                          </div>
                        ))
                      ) : (
                        <p>No history available</p>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex flex-row mt-4">
                <button
                  className="btn-main lead mr-3"
                  onClick={() => setIsModalOpen(true)}
                >
                  Buy Now
                </button>
                <button
                  className="btn-main btn2 lead"
                  onClick={() => setShowBidModal(true)}
                >
                  Make an Offer
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Offer Modal */}
      {showBidModal && (
        <div className="bid-modal">
          <div className="bid-modal-content">
            <button
              onClick={() => setShowBidModal(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-red-500 text-lg"
            >
              ✖
            </button>
            <h3>Make Your Offer</h3>
            <p>Current Price: {nft?.price || "N/A"} ꜩ</p>
            <div className="bid-modal-inputdiv">
              <input
                type="number"
                value={bidAmount}
                min={0.1}
                onChange={(e) => handleBidChange(e, toTez(nft.currentBid))}
                placeholder="Enter Offer amount 1 ꜩ or 2.05 ꜩ"
              />
            </div>
            {bidError && nft.currentBid && (
              <p className="text-red-500 text-sm mt-1 mb-2 text-left text-left">
                Offer amount must be higher than the current offer of{" "}
                {toTez(nft.currentBid)} ꜩ
              </p>
            )}
            <div className="bid-modal-btnmaindiv">
              <button
                className="btn-main"
                onClick={() => console.log("Offer placed:", bidAmount)}
                disabled={!bidAmount || bidError}
              >
                Submit
              </button>
              <button
                className="btn-clear"
                onClick={() => {
                  setShowBidModal(false);
                  setBidError(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Buy Modal */}
      {isModalOpen && (
        <div className="buy-modal">
          <div className="buy-modal-content">
            <h3>Confirm Purchase</h3>
            <p>Price: {nft?.price || "N/A"} ꜩ</p>
            <button
              className="btn-main"
              onClick={() => console.log("NFT Purchased")}
            >
              Buy Now
            </button>
            <button className="btn-clear" onClick={() => setIsModalOpen(false)}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleNFT;
